import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import SearchResultsBody from './searchresultsbody';

const SearchResults = ({ keywords, searchText, suggestedKeywords }) => {
  searchText = searchText.trim().toLowerCase();

  if (!searchText) {
    return (
      <SearchResultsBody
        major="Type what you’re trying to do above"
        minor="and I'll see if I have a keyword to match!"
        results={suggestedKeywords}
      />
    );
  }

  const results = keywords.filter(
    (keyword) =>
      keyword.keyword.toLowerCase().includes(searchText) ||
      keyword.description
        .toLowerCase()
        .replace(/\s+/gi, '')
        .includes(searchText)
  );

  if (!results.length) {
    return (
      <SearchResultsBody
        major="Sorry, I didn’t find a matching keyword!"
        minor="Please clear your search and type something else, or try one of&nbsp;these:"
        results={suggestedKeywords}
      />
    );
  }

  return (
    <SearchResultsBody
      major={`${results.length} ${pluralize(`result`, results.length)}`}
      minor="Text one of these keywords to the bot"
      results={results}
    />
  );
};

SearchResults.propTypes = {
  keywords: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      keyword: PropTypes.string.isRequired,
    })
  ).isRequired,
  searchText: PropTypes.string.isRequired,
  suggestedKeywords: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      keyword: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SearchResults;
